export enum SeriesType {
    line,
    area,
    bars,
    candlesticks,
    steppedArea
}